import type { CustomItemsInsightsReportState } from './CustomItemsInsightsReportState';
import {
    initialCustomItemsInsightsReportState,
    emptyCustomItemsInsightsReport
} from './CustomItemsInsightsReportState';
import type { CustomItemsInsightsReportAction } from 'actions/insights/sales/customItemsInsightsReport/CustomItemsInsightsReportActionsTypes';

import {
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR,
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START,
    CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS
} from 'actions/insights/sales/customItemsInsightsReport/CustomItemsInsightsReportActionsTypes';

export const customItemsInsightsReportReducer = (
    state: CustomItemsInsightsReportState = initialCustomItemsInsightsReportState,
    action: CustomItemsInsightsReportAction
): CustomItemsInsightsReportState => {
    switch (action.type) {
        case CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START:
            return { ...state, loading: true };

        case CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS:
            return { loading: false, report: action.payload.report };

        case CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR:
            return { loading: false, report: emptyCustomItemsInsightsReport() };

        default:
            return state;
    }
};
